import IonAlert from '../../../../../components/Modal/ModalAlert';
import IonToolbar from '../../../../../components/Modal/ModalToolbar';
import { useModalAlert as useIonAlert } from '../../../../../components/Modal/ModalAlert';
// import '@capacitor-community/http';
import { IonButton, IonButtons, IonContent, IonFooter, IonHeader, IonIcon, IonItem, IonLabel, IonList, IonLoading, IonPage, IonTextarea, IonTitle, IonToast, useIonViewDidEnter } from '@ionic/react';
import imageCompression from 'browser-image-compression';
import { Buffer } from 'buffer';
import { arrowBack, businessOutline, cloudUploadOutline, imageOutline, saveOutline } from 'ionicons/icons';
import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { empresaAlterar, empresaConfiguracoesCarregar, onboardingAtualizarEtapa, requestService } from '../../../../../Utils/Services';
import OnboardingContextBanner from '../../../../../components/Onboarding/OnboardingContextBanner';
import { useGooglePlacesSimple } from '../../../../../components/useGooglePlacesSimple';
import { MessageContext } from '../../../../../contexts/MessageContext';
import { OnboardingContext } from '../../../../../contexts/OnboardingContext';
import imgDefaultImage from '../ProdutosCategoriasNovo/imgs/defaultImage.svg';
import './ContaAlt.css';

type Props = {
  abrirMenu: boolean;
};

const ContaAlt: React.FC<Props> = (props: Props) => {

  const history = useHistory();

  const [showToast2, setShowToast2] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [textToast, setTextToast] = useState("");

  const [showLoading, setShowLoading] = useState(true);
  const [showSucesso, setShowSucesso] = useState(false);

  const { loja, setLoja } = useContext(MessageContext);
  const { onboardingData, setOnboardingData } = useContext(OnboardingContext);
  const [acessos] = useState<any>(JSON.parse(window.localStorage.getItem("acessos") || '{}'));
  const { esconderMenu, setEsconderMenu } = useContext(MessageContext);
  const { nomeMenu, setNomeMenu } = useContext(MessageContext);

  const [empresaNome, setEmpresaNome] = useState('');
  const [empresaEndereco, setEmpresaEndereco] = useState('');
  const [empresaTelefone, setEmpresaTelefone] = useState('');
  const [empresaLatitude, setEmpresaLatitude] = useState('');
  const [empresaLongitude, setEmpresaLongitude] = useState('');
  const [urlLogo, setUrlLogo] = useState('');

  const [fileDataURL, setFileDataURL] = useState<any>(null);
  const [fileArquivos, setFileArquivos] = useState<any>();
  const imageMimeType = /image\/(png|jpg|jpeg|avif|webp)/i;


  const [mostartAlerta] = useIonAlert();
  const [localEnderecoSelecionado, setLocalEnderecoSelecionado] = useState<any>("");

  // Flag para evitar busca automática quando preenchemos programaticamente
  const [ignorarProximaMudanca, setIgnorarProximaMudanca] = useState(false);

  // Hook Google Places Simple para endereços (sem validação de entrega)
  const {
    listaEnderecos,
    buscandoEndereco,
    buscarSugestoes: buscarSugestoesEndereco,
    buscarDetalhes: buscarDetalhesEnderecoHook,
    limparSugestoes
  } = useGooglePlacesSimple({
    onError: (mensagem) => {
      setTextToast(mensagem);
      setShowToast(true);
    },
    onLoading: setShowLoading,
    debounceTime: 2000,
    minChars: 4
  });

  // Função para buscar detalhes do endereço selecionado
  const buscarDetalhesEndereco = async (placeId: string, enderecoFormatado: string) => {
    try {
      const detalhes = await buscarDetalhesEnderecoHook(placeId, enderecoFormatado);

      // Preencher campos automaticamente (sem disparar busca)
      setIgnorarProximaMudanca(true);
      setEmpresaEndereco(detalhes.endereco);
      setEmpresaLatitude(detalhes.latitude.toString());
      setEmpresaLongitude(detalhes.longitude.toString());

      setTextToast("Endereço validado com sucesso.");
      setShowToast(true);

    } catch (error) {
      console.error("Erro ao buscar detalhes:", error);
    }
  };

  // Handler para seleção de item da lista de sugestões
  const handleSelectItemEndereco = (item: any) => {
    console.log("Item selecionado:", item);

    // Limpar lista de sugestões
    limparSugestoes();

    buscarDetalhesEndereco(item.placeId, item.descricao);
  };

  useIonViewDidEnter(() => {
    setEsconderMenu(true);
    setNomeMenu("");
    carregarConta();
  });

  useEffect(() => {
    let fileReader: FileReader, isCancel = false;
    if (fileArquivos) {
      fileReader = new FileReader();
      fileReader.onload = (e) => {
        const result = e.target;
        if (result && !isCancel) {
          setFileDataURL(result.result);
        }
      }
      fileReader.readAsDataURL(fileArquivos);
    }
    return () => {
      isCancel = true;
      if (fileReader && fileReader.readyState === 1) {
        fileReader.abort();
      }
    }
  }, [fileArquivos]);

  function carregarConta() {

    const consultar = async () => {

      console.log("aasasasasa", loja);
      let id = loja;

      requestService(empresaConfiguracoesCarregar.url.replace("{id}", id.replaceAll(/#/g, '%23')).concat("?filtro=", Buffer.from(loja).toString("base64")), {
        method: empresaConfiguracoesCarregar.method,
        headers: [
          ["token", window.localStorage.getItem("token")]
        ],
        credentials: 'include'
      },
        history,
        (response: any) => {
          console.log(response);
          setEmpresaNome(response.Item.empresaNome || '');
          setEmpresaEndereco(response.Item.empresaEndereco || '');
          setEmpresaTelefone(formataTelefone(response.Item.empresaTelefone) || '');
          setEmpresaLatitude(response.Item.empresaLatitude || '');
          setEmpresaLongitude(response.Item.empresaLongitude || '');
          setUrlLogo(response.Item.urlLogo || '');

          setShowLoading(false);
        },
        (error: any) => {
          console.log(error);
          history.replace("/login/");
        });

    }

    consultar();
  }

  function formataTelefone(numero: any) {
    if (numero?.length == 13) {
      let BRNumber = numero.replace("55", "").match(/(\d{2})(\d{5})(\d{4})/);
      BRNumber = "(" + BRNumber[1] + ") " + BRNumber[2] + "-" + BRNumber[3];
      return BRNumber;
    }
    else if (numero?.length == 12) {
      let BRNumber = numero.replace("55", "").match(/(\d{2})(\d{4})(\d{4})/);
      BRNumber = "(" + BRNumber[1] + ") " + BRNumber[2] + "-" + BRNumber[3];
      return BRNumber;
    }
    else { return ""; }
  }

  const cadastrar = () => {

    let validadorCelular = /^((\+?55\ ?[1-9]{2}\ ?)|(\+?55\ ?\([1-9]{2}\)\ ?)|(0[1-9]{2}\ ?)|(\([1-9]{2}\)\ ?)|([1-9]{2}\ ?))((\d{4}\-?\d{4})|(9[1-9]{1}\d{3}\-?\d{4}))$/;

    if (empresaTelefone && !validadorCelular.test(empresaTelefone)) {
      setTextToast("Telefone inválido.");
      setShowToast(true);
      return;
    }

    setShowToast2(true);
  }

  // Função para reduzir tamanho da foto
  async function ReduzirFoto(file: File) {
    const options = {
      maxSizeMB: 0.5,
      maxWidthOrHeight: 1102,
      useWebWorker: true,
      initialQuality: 0.5
    }
    return await imageCompression(file, options);
  }

  // Método chamado quando é selecionado um arquivo para subida
  async function ChangeHandlerInputFile(e: any) {
    const file = e.target.files[0];
    if (file) {
      if (!file.type.match(imageMimeType)) {
        alert("Tipo da imagem inválido");
        return;
      }

      const fotoReduzida = await ReduzirFoto(file);
      console.log("Tamanho comprimido:", fotoReduzida.size);
      setFileArquivos(fotoReduzida);
    }
    else {
      alert("Arquivo não selecionado");
      return;
    }
  }

  async function getBase64(file: any) {
    return new Promise((resolve) => {
      const reader = new FileReader()
      reader.onloadend = () => resolve(reader.result)
      reader.readAsDataURL(file)
    })
  }

  function onInputTelefone(e: any) {
    // Remove todos os caracteres que não são números
    let apenasNumeros = e.target.value.replace(/[^\d]/g, '');

    // Limita a 11 dígitos (DDD + número)
    if (apenasNumeros.length > 11) {
      apenasNumeros = apenasNumeros.substring(0, 11);
    }

    // Se não há números, limpa o campo
    if (apenasNumeros.length === 0) {
      setEmpresaTelefone('');
      return;
    }

    // Aplica a máscara
    let telefoneFormatado = '';

    if (apenasNumeros.length > 0) {
      telefoneFormatado = '(' + apenasNumeros.substring(0, Math.min(2, apenasNumeros.length));

      if (apenasNumeros.length >= 2) {
        telefoneFormatado += ') ';
      }

      if (apenasNumeros.length > 2) {
        telefoneFormatado += apenasNumeros.substring(2, Math.min(7, apenasNumeros.length));
      }

      if (apenasNumeros.length > 7) {
        telefoneFormatado += '-' + apenasNumeros.substring(7, 11);
      }
    }

    setEmpresaTelefone(telefoneFormatado);
  }

  // async function incluirFoto() {
  //   if (!fileArquivos) {
  //     alert("Nenhuma imagem selecionada");
  //     return;
  //   }

  //   const atualizar = async () => {
  //     var token: string = "";
  //     var tkn = localStorage.getItem("token");
  //     if (typeof (tkn) === "string") { token = tkn; }

  //     // Converter arquivo para base64
  //     const base64 = await getBase64(fileArquivos);

  //     let parametros = {
  //       base64: base64
  //     }

  //     try {
  //       setShowLoading(true);

  //       const resp = await fetch(empresaAlterar.url.replace("{id}", loja.replaceAll("#", "%23")).concat("?tipo=logoempresa"),
  //         {
  //           method: empresaAlterar.method,
  //           headers: [
  //             ["token", token]
  //           ],
  //           body: JSON.stringify(parametros),
  //           credentials: 'include'
  //         });

  //       const response = await resp.json();

  //       console.log("response", response);
  //       if (response.Item) {
  //         setUrlLogo(response.Item);
  //         setFileDataURL(response.Item);
  //         setFileArquivos(null);
  //       }
  //       setShowLoading(false);

  //     } catch (error) {
  //       console.log("erro", error);
  //       setShowLoading(false);
  //     }
  //   }

  //   atualizar();
  // };

  // Função antiga comentada - agora usamos Google Places
  /*
  function buscarLocalizacao(endereco: any) {
    if (endereco.replace(/\s/g, "") == "") return;

    let enderecoTratado = endereco.toLowerCase().replace(/\s/g, "+");


    requestService(buscarEndereco.url.replace("{id}", enderecoTratado), {

      method: buscarEndereco.method,
      headers: [
        ["token", window.localStorage.getItem("token")]
      ],
      credentials: 'include'
    },
      history,
      (response: any) => {
        if (response && response.Item) {
          try {
            setEmpresaLatitude(response.Item.enderecoLat);
            setEmpresaLongitude(response.Item.enderecoLng);

            setTextToast("Endereço validado com sucesso.");
            setShowToast(true);
          } catch (error) {
            console.log("error", error);
          }

        }
      },
      (error: any) => {
        console.log("e1", error);
        setTextToast(error.message);
        setShowToast(true);
        if (error.data) {
          console.log("entrou varios endereços");
          if (Array.isArray(error.data) && error.data.length > 0) {
            // setListaEnderecos(error.data);
          }
        }
      }).finally(() => { setShowLoading(false); });
    ;
  }

  function readListaEnderecos() {
    return listaEnderecos.map((value: any, index: any) => (
      <IonItem
        key={"endereco" + value.place_id}
        button
        onClick={() => setLocalEnderecoSelecionado(value.formatted_address)}
        color={localEnderecoSelecionado === value.formatted_address ? 'tertiary' : ''}
      >
        <IonLabel>{value.formatted_address}</IonLabel>
      </IonItem>
    ));
  }
  */



  return (
    <IonPage className="conta-alt-page">
      <IonHeader className="ion-no-border">
        <IonToolbar className="conta-alt-toolbar">


          <IonButtons slot="start">
            <IonButton aria-label="Voltar" onClick={() => { history.goBack(); }}><IonIcon slot="icon-only" icon={arrowBack} /></IonButton>
          </IonButtons>


          <IonTitle slot="start">Perfil</IonTitle>
        </IonToolbar>
        <OnboardingContextBanner />
      </IonHeader>
      <IonContent className="conta-alt-content">
        <main className="conta-alt-container">
          <header className="conta-alt-intro">
            <h1>Dados do estabelecimento</h1>
            <p>Mantenha as informações e a identidade da sua loja atualizadas.</p>
          </header>
          <div className="conta-alt-grid">
            <section className="conta-alt-section" aria-labelledby="conta-alt-dados-title">
              <header className="conta-alt-section-header">
                <span className="conta-alt-section-icon"><IonIcon icon={businessOutline} aria-hidden="true" /></span>
                <div><h2 id="conta-alt-dados-title">Informações da loja</h2><p>Nome, contato e localização do seu estabelecimento.</p></div>
              </header>
              <div className="conta-alt-fields">
                <div className="conta-alt-field">
                  <label htmlFor="conta-alt-nome">Nome da empresa</label>
                  <IonTextarea id="conta-alt-nome" aria-label="Nome da empresa" rows={1} autoGrow value={empresaNome} maxlength={100} placeholder="Nome da empresa" onIonInput={(e: any) => setEmpresaNome(e.target.value)} />
                </div>
                <div className="conta-alt-field">
                  <label htmlFor="conta-alt-telefone">Celular</label>
                  <IonTextarea id="conta-alt-telefone" aria-label="Celular" inputmode="tel" rows={1} value={empresaTelefone} maxlength={15} placeholder="(__) _____-____" onIonInput={onInputTelefone} />
                </div>
                <div className="conta-alt-field conta-alt-field-full">
                  <label htmlFor="conta-alt-endereco">Endereço</label>
                  <IonTextarea id="conta-alt-endereco" aria-label="Endereço" aria-describedby="conta-alt-endereco-hint" rows={2} autoGrow value={empresaEndereco} maxlength={200} placeholder="Busque o endereço da empresa"
              onIonInput={(e: any) => {
                const valor = e.target.value || "";
                setEmpresaEndereco(valor);

                // Se flag estiver ativa, ignorar busca (foi preenchimento automático)
                if (ignorarProximaMudanca) {
                  setIgnorarProximaMudanca(false);
                  return;
                }

                // Buscar sugestões automaticamente
                buscarSugestoesEndereco(valor);
              }}
              onKeyDown={(e: any) => {
                // Enter força busca imediata
                if (e.key === "Enter") {
                  e.preventDefault();
                  const valor = empresaEndereco || '';
                  if (valor.trim().length >= 4) {
                    buscarSugestoesEndereco(valor, true);
                  } else {
                    setTextToast('Digite no mínimo 4 caracteres para buscar.');
                    setShowToast(true);
                  }
                }
              }}
                  />
                  <p id="conta-alt-endereco-hint" className="conta-alt-field-hint">Digite o endereço e selecione uma sugestão para confirmar a localização.</p>
                  {buscandoEndereco && <p className="conta-alt-field-hint" role="status">Buscando endereços...</p>}
                  {listaEnderecos?.length > 0 && (
                    <div className="conta-alt-address-suggestions" aria-label="Sugestões de endereço">
                      {listaEnderecos.map((item: any, index: any) => (
                        <button type="button" key={"sugestao" + index} onClick={() => handleSelectItemEndereco(item)}>
                          <strong>{item.descricaoPrincipal}</strong>
                          {item.descricaoSecundaria && <span>{item.descricaoSecundaria}</span>}
                        </button>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </section>
            <section className="conta-alt-section" aria-labelledby="conta-alt-logo-title">
              <header className="conta-alt-section-header">
                <span className="conta-alt-section-icon"><IonIcon icon={imageOutline} aria-hidden="true" /></span>
                <div><h2 id="conta-alt-logo-title">Logo da loja</h2><p>A identidade visual do seu negócio.</p></div>
              </header>
              <div className="conta-alt-logo-body">
                <div className="conta-alt-logo-preview"><img id="imagemLogo" alt="Logo da loja" src={fileDataURL || urlLogo || imgDefaultImage} /></div>
                <label className="conta-alt-file-control">
                  <IonIcon icon={cloudUploadOutline} aria-hidden="true" />Selecionar imagem
                  <input id="conta-alt-logo" onChange={ChangeHandlerInputFile} type="file" accept="image/*" aria-label="Selecionar imagem da logo" aria-describedby="conta-alt-logo-hint" />
                </label>
                {fileArquivos && <p className="conta-alt-file-name">{fileArquivos.name}</p>}
                <p id="conta-alt-logo-hint" className="conta-alt-field-hint">PNG, JPG, JPEG, AVIF ou WebP. A imagem será atualizada ao salvar.</p>
              </div>
            </section>
          </div>
        </main>
        <IonToast
          isOpen={showToast}
          position="middle" //top, bottom, middle
          onDidDismiss={() => setShowToast(false)}
          message={textToast}
          duration={3000}
        />

        <IonAlert isOpen={showToast2}
          onDidDismiss={() => setShowToast2(false)}
          header={'Alterar perfil'}
          message={'Você <strong>confirma</strong> a alteração?'}
          buttons={[
            {
              text: 'Cancelar',
              role: 'cancel',
            },
            {
              text: 'Confirmar',
              cssClass: 'primary',
              handler: async () => {

                setShowLoading(true);

                // Preparar objeto base
                const objectRequest: any = {
                  empresaNome,
                  empresaEndereco,
                  empresaTelefone: "55" + empresaTelefone.replace("(", "").replace(")", "").replace(" ", "").replace("-", ""),
                  empresaLatitude,
                  empresaLongitude
                };

                // Se houver nova logo selecionada, incluir base64 no request
                if (fileArquivos) {
                  const base64 = await getBase64(fileArquivos);
                  objectRequest.base64 = base64;
                }

                let id = loja;

                console.log("id", id)

                requestService(
                  empresaAlterar.url.replace("{id}", id.replaceAll("#", "%23")).concat("?tipo=perfil"),
                  {
                    method: empresaAlterar.method,
                    body: JSON.stringify(objectRequest),
                    headers: [
                      ["token", window.localStorage.getItem("token")]
                    ],
                    credentials: 'include'
                  },
                  history,
                  (response: any) => {
                    console.log(response);
                    if (response) {
                      // Atualizar urlLogo se houver resposta com nova logo
                      if (response.Item && fileArquivos) {
                        setUrlLogo(response.Item.urlLogo || response.Item);
                        setFileDataURL(null);
                        setFileArquivos(null);
                      }

                      setTextToast("Alteração realizado com sucesso.");
                      setShowSucesso(true);

                      // Marcar etapa do onboarding como concluída
                      if (onboardingData && !onboardingData.onboarding_concluido) {
                        const urlOnb = onboardingAtualizarEtapa.url
                          .replace("{empresa_id}", onboardingData.empresa_id.replaceAll("#", "%23"));
                        requestService(urlOnb, {
                          method: onboardingAtualizarEtapa.method,
                          body: JSON.stringify({ etapa_id: 'dados_estabelecimento', status: 'concluido' }),
                          headers: [["token", window.localStorage.getItem("token")]],
                          credentials: 'include'
                        }, history, (r: any) => { if (r) setOnboardingData(r); }, () => { });
                      }

                    } else if (response.status === 400) {
                      console.log(response);
                      setTextToast("Ocorreu um erro ao efetuar a alteração.");
                      setShowToast(true);

                    }
                    setShowLoading(false);
                  },
                  (error: any) => {
                    console.log(error);
                    setTextToast("Ocorreu um erro ao efetuar a alteração.");
                    setShowToast(true);
                    setShowLoading(false);
                  })
              }
            }
          ]}
        />

        {/* Modal antigo comentado - agora usamos Google Places inline */}
        {/*
        <IonModal isOpen={(Array.isArray(listaEnderecos) && listaEnderecos.length > 0)} onDidDismiss={() => { setListaEnderecos([]); }}>
          <IonHeader>
            <IonToolbar color="primary">
              <IonTitle>Selecione um endereço</IonTitle>
              <IonButtons slot="start" onClick={() => setListaEnderecos([])}>
                <IonIcon slot="icon-only" icon={arrowBack}></IonIcon>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent className="ion-padding">
            <IonList>
              {readListaEnderecos()}
            </IonList>
          </IonContent>
          <IonFooter>
            <IonButton expand="block" color="primary" onClick={(e) => {

              mostartAlerta({
                backdropDismiss: false,
                header: 'Número e complemento',
                message: 'Adicione número e complemento',
                inputs: [
                  {
                    name: 'mensagem',
                    type: 'textarea',
                    id: 'name2-id',
                    placeholder: 'Digite aqui o número e complemento',
                  }],
                buttons: ['Cancel', {
                  text: 'OK', handler: (d) => {
                    setEmpresaEndereco(empresaEndereco + ", " + d.mensagem);
                    // todo: precisa trocar para utilizar da propria lista
                    buscarLocalizacao(localEnderecoSelecionado + ", " + d.mensagem);
                  }
                }],
                onDidDismiss: (e) => { console.log('did dismiss'); }
              })

              setListaEnderecos([]);
            }}>Avançar</IonButton>
          </IonFooter>
        </IonModal>
        */}

        <IonLoading
          cssClass='my-custom-class'
          isOpen={showLoading}
          onDidDismiss={() => { setShowLoading(false); }}
          spinner='circles'
        />

        <IonLoading
          cssClass='my-custom-class'
          isOpen={showSucesso}
          onDidDismiss={(e: any) => { setShowSucesso(false); history.goBack(); }}
          message={'Alterações salvas com sucesso!'}
          duration={3000}
          animated={false}
        />
      </IonContent >
      <IonFooter className="ion-no-border conta-alt-footer" hidden={acessos?.configuracoes != 'edicao'}>
        <div className="conta-alt-footer-inner">
          <p>Revise os dados antes de salvar as alterações.</p>
          <IonButton className="conta-alt-save" onClick={() => cadastrar()} type="submit"><IonIcon icon={saveOutline} slot="start" aria-hidden="true" />Salvar alterações</IonButton>
        </div>
      </IonFooter>
    </IonPage >
  );
};

export default ContaAlt;
